import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import moment from "moment";
import ReactTooltip from "react-tooltip";

//import filter modal
import FilterModal from "../../components/Modal/FilterModal.js";
import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequest,
  putRequestForm,
  postRequestForm,
} from "../../components/Common/Utils.js";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";

const filterObj = {
  venueName: "",
  userName: "",
  title: "",
  stars: "",
  review: "",
  reply: "",
  status: "",
  createdAt: "",
};

const ProductesTable = ({ userId }) => {

  const history = useHistory();

  const [modal_center, setmodal_center] = useState(false);
  const [Productdata, setProductdata] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [manufactuereId, setManufactuereId] = useState("");

  const [value, setValue] = React.useState(10);
  const [totalCartAmount, setTotalCartAmount] = React.useState(0);

  const [sort, setsort] = React.useState("createdAt");
  const [sortOrder, setsortOrder] = React.useState("desc");


  const [currentFPage, setCurrentFPage] = useState(1);
  const [cartTotalItem, setCartTotalItem] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [image, setImage] = React.useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [model, setModel] = useState(false);
  const [filter, setFilter] = useState({ ...filterObj });

  const [loader2, setLoader2] = useState(false);

  const GetValueOnChange = async (value, _id) => {
    let actId = _id;

    const payload = {
      productId: actId,
      isPublished: value
    }
    // const formData = new FormData();
    // formData.append("ProductId", actId);
    // formData.append("isPublished", status);
    const res = await postRequest("product/update-by-admin", payload);
    if (res.status) {
      toast.success("Product Status updated Successfully");
      ProductManagment();
    } else {
      toast.error("Something went wrong");
      setLoader(false);
    }
  };

  useEffect(() => {
    ProductManagment();
  }, [currentPage]);

  useEffect(() => {
    ProductManagment();
  }, [sizePerPageOrg, sort, sortOrder]);

  const closeModal = () => {
    setModel(false);
  };

  const toggleModel = () => {
    console.log("toggleModel", model);
    setModel(!model);
  };


  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }

    console.log("type", type);

    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  const updateFilter = (key, value) => {
    const filterObj = { ...filter };
    filterObj[key] = value;
    setFilter(filterObj);
  };

  const applyFilter = () => {
    const filterArgs = [];

    Object.keys(filter).forEach((key) => {
      if (
        filter[key] !== "" &&
        filter[key] !== null &&
        filter[key] !== undefined
      ) {


        var filterObject = {
          [key]: filter[key],
        };


        if (key === "venueName" || key === "userName" || key === "review" || key === "reply") {
          filterObject.type = "regex";
        } else if (key === "status" || key === "stars") {
          filterObject.type = "eq";
        } else if (key === "createdAt") {
          filterObject.type = "date-eq";
        }

        filterArgs.push(filterObject);
      }
    });

    console.log("filterArgs", filterArgs);
    toggleModel();
    ProductManagment(filterArgs);
  };

  const resetFilter = () => {
    setFilter({ ...filterObj });
    toggleModel();
    ProductManagment();
  };

  const defaultSorted = [
    {
      dataField: "_id",
      order: "asc",
    },
  ];

  function tog_center() {
    setmodal_center(!modal_center);
    removeBodyCss();
  }

  function activeFormatter(cellContent, row) {
    return (
      <>
        {row.isPublished ? (
          <>
            <button
              className="btn btn-active"
              type="button"
              onClick={() => GetValueOnChange((row.isPublished = false), row._id)}
            >
              Active
            </button>
          </>
        ) : (
          <>
            <button
              className="btn btn-deactive"
              type="button"
              onClick={() => GetValueOnChange((row.isPublished = true), row._id)}
            >
              InActive
            </button>
          </>
        )}
      </>
    );
  }

  function createdAtdata(cellContent, row) {
    return (
      <React.Fragment>
        <div>
          <p>{moment(row.createdAt).format("DD-MM-YYYY")} </p>
        </div>
      </React.Fragment>
    );
  }


  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }



  function ProductFormatter(cellContent, row) {
    return (
      <>
        <img
          src={row.images[0]}
          onClick={() => showLightBox(row.images[0])}
          alt="Not found Product"
          width={"50px"}
        />
      </>
    );
  }

  function PriceFormatter(cellContent, row) {
    return (
      <>
        <div className="d-flex align-items-center">
          <p className="mb-0" style={{ fontSize: '16px', whiteSpace: 'nowrap' }}>
            {/* {row?.price} */}
            <span style={{ color: '#29bbe3' }}>${row?.price ? <>{row?.price}</> : <>{row?.priceRange?.[0]?.price}</>}</span>
          </p>
          <i
            data-tip
            data-for={`title-tooltip${row?._id}`}
            className="fa fa-info-circle"
            style={{ marginLeft: '5px', cursor: 'pointer', fontSize: '20px' }}
          ></i>
        </div>

        <ReactTooltip id={`title-tooltip${row?._id}`} place="bottom">
          {row?.priceRange.map((price) => {
            return (
              <>
                <p className="mb-0">
                  Quantity Range&nbsp;:&nbsp;{price?.minQuantity} - {price?.maxQuantity}&nbsp;
                  Price : ${price?.price}
                </p>
              </>
            )
          })}
        </ReactTooltip>
      </>
    );
  }


  const components = [
    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Venue</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.venueName}
          onChange={(e) => updateFilter("venueName", e.target.value)}
          name="venue"
          className="form-control"
        />
      </div>
    </div>,

    <div className="row mb-4" key="amount">
      <label className="col-sm-3 col-form-label">User</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.userName}
          onChange={(e) => updateFilter("userName", e.target.value)}
          name="user"
          className="form-control"
        />
      </div>
    </div>,

    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Title</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.title}
          onChange={(e) => updateFilter("title", e.target.value)}
          name="title"
          className="form-control"
        />
      </div>
    </div>,

    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Stars</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.stars}
          onChange={(e) => updateFilter("stars", e.target.value)}
          name="stars"
          className="form-control"
        />
      </div>
    </div>,
    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Review</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.review}
          onChange={(e) => updateFilter("review", e.target.value)}
          name="review"
          className="form-control"
        />
      </div>
    </div>,
    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Reply</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.reply}
          onChange={(e) => updateFilter("reply", e.target.value)}
          name="reply"
          className="form-control"
        />
      </div>
    </div>,

    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Status</label>
      <div className="col-sm-6">
        <select
          onChange={(e) => updateFilter("status", e.target.value)}
          className="form-select"
        >
          <option value="">Select Status</option>
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </select>
      </div>
    </div>,

    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Created Date</label>
      <div className="col-sm-6">
        <input
          type="date"
          value={filter.createdAt}
          onChange={(e) => updateFilter("createdAt", e.target.value)}
          name="createdAt"
          className="form-control"
        />
      </div>
    </div>,

    // submit button

    <div className="mt-5 mt-lg-4" key="submit">
      <div className="row justify-content-end">
        <div className="col-sm-9">
          <div>
            <button
              type="button"
              onClick={applyFilter}
              className="btn btn-primary w-md"
            >
              Filter
            </button>
            <button
              onClick={resetFilter}
              type="button"
              className="btn btn-danger w-md mx-4"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>,
  ];

  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },

    {
      dataField: "images[]",
      text: "Product image",
      sort: false,
      formatter: ProductFormatter,
    },

    {
      dataField: "name",
      text: "Product Name",
      sort: false,
    },
    {
      // dataField: "Price",
      text: "Price",
      formatter: PriceFormatter,
      sort: false,
    },
    {
      dataField: "minimumQuantity",
      text: "Minimum Quantity",
      sort: false,
    },
    {
      dataField: "unit",
      text: "Unit",
      sort: false,
    },

    {
      text: "Status",
      sort: false,
      formatter: activeFormatter,
    },
    {
      text: "Add To Cart",
      sort: false,
      formatter: addToCartFormatter,
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: iconFormatter,
      sort: false,
    },
  ];

  function userFormatter(cellContent, row) {
    return (
      <div style={{ display: 'flex', gap: '10px' }}>
        <img
          src={row.userImage}
          onClick={() => showLightBox(row.userImage)}
          alt="Image"
          width={"50px"}
          style={{ borderRadius: '20%' }} // This makes the image round
        />
        <p>{row.userName}</p>
      </div>
    );
  }

  function hotelFormatter(cellContent, row) {
    return (
      <div style={{ display: 'flex', gap: '10px' }}>
        {/* <img
        src={row?.type == 'hotel' ?  row?.hotelData?.image[1]?.fileName : row?.type == 'transfer' ? row?.transferData?.image[1]?.fileName : row?.type == 'ticket' ? `https://ui-avatars.com/api/?background=random&name=${row?.ticketData?.name}` : '' }
        onClick={() => showLightBox(row?.type == 'hotel' ?  row?.hotelData?.image[0]?.fileName : row?.type == 'transfer' ? row?.transferData?.image[0]?.fileName : row?.type == 'ticket' ? `https://ui-avatars.com/api/?background=random&name=${row?.ticketData?.name}` : '')}
        alt="Image"
        width={"50px"}
        style={{ borderRadius: '20%' }} // This makes the image round
      /> */}
        <p>{row?.type == 'hotel' ? row?.hotelData?.name : row?.type == 'ticket' ? row?.ticketData?.name : row?.transferData?.name}</p>
      </div>
    );
  }

  // const handleChange = (event) => {
  //   setSizePerPage(event.target.value);
  // };
  const handlesorting = (event) => {
    setsort(event.target.value);
  };
  const handlesortOrder = (event) => {
    setsortOrder(event.target.value);
  };
  const handleReload = () => {
    setSearchText(" ");
    ProductManagment();
  };

  function iconFormatter(cellContent, row) {
    return (
      <React.Fragment>
        <div className="d-flex">
          <button type="button" className=" btn btn-info  mx-2">
            {" "}
            <Link
              to={{
                pathname: `/product-details/${row?._id}`,
                state: { row },
              }}
            >
              {" "}
              <i class="fal fa-eye text-light"></i>
            </Link>{" "}
          </button>
          {/* <button type="button" className=" btn btn-info  mx-2">
            {" "}
            <Link
              to={{
                pathname: `/addReply/${row._id}`,
                state: { row },
              }}
            >
              {" "}
              <i class="fal fa-reply fs-5 text-light"></i>
            </Link>{" "}
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handlerdelete(row._id)}
          >
            <i class="fal fa-trash  fs-5"></i>
          </button> */}
          &nbsp;&nbsp;
        </div>
      </React.Fragment>
    );
  }

  const [addedToCart, setAddedToCart] = useState(new Set()); // Track added items
  const [cartQuantities, setCartQuantities] = useState(new Map()); // Track quantities

  const handleAddToCart = (itemId) => {
    const isItemAdded = addedToCart.has(itemId);
    const row = Productdata.find((item) => item._id === itemId);
    const minimumQuantity = row?.minimumQuantity || 1; // Use minimum quantity if defined

    // Determine the price based on the quantity and priceRange
    const getPriceForQuantity = (quantity) => {
      const range = row?.priceRange?.find(
        (priceRange) =>
          quantity >= priceRange.minQuantity && quantity <= priceRange.maxQuantity
      );
      return range?.price || 0; // Default to 0 if no range matches
    };

    setAddedToCart((prevAddedToCart) => {
      const updatedSet = new Set(prevAddedToCart);
      if (isItemAdded) {
        updatedSet.delete(itemId); // Remove item from cart
      } else {
        updatedSet.add(itemId); // Add item to cart
      }
      return updatedSet;
    });

    setCartQuantities((prevCartQuantities) => {
      const updatedMap = new Map(prevCartQuantities);
      if (isItemAdded) {
        updatedMap.delete(itemId); // Remove item from cart quantities
      } else {
        updatedMap.set(itemId, minimumQuantity); // Set initial quantity
      }
      return updatedMap;
    });

    setProductdata((prevProductdata) => {
      // Check if the product is already in the cart
      const existingProductIndex = prevProductdata.findIndex((item) => item._id === itemId);

      if (existingProductIndex !== -1) {
        // If product is already in the cart, update the quantity, price, and addToCart key
        return prevProductdata.map((item) => {
          if (item._id === itemId) {
            const updatedQuantity = (cartQuantities.get(itemId) || 0) + 1;
            const updatedPrice = getPriceForQuantity(itemId, updatedQuantity);
            return {
              ...item,
              quantity: updatedQuantity,
              price: updatedPrice,
              addToCart: true // Set addToCart to true
            };
          }
          return item;
        });
      } else {
        // If product is not in the cart, add it and set addToCart to true
        const newItem = Productdata.find((item) => item._id === itemId);
        const newItemWithQuantityAndPrice = {
          ...newItem,
          quantity: 1, // Add the item with quantity 1 initially
          price: getPriceForQuantity(itemId, 1), // Calculate price for quantity 1
          addToCart: true // Set addToCart to true
        };
        return [...prevProductdata, newItemWithQuantityAndPrice]; // Add to cart
      }
    });
  };


  const calculateTotalPrice = () => {
    let totalPrice = 0;

    // Safeguard against empty cart or product data
    if (!cartQuantities || cartQuantities.size === 0) {
      console.warn("Cart quantities are empty.");
      return totalPrice;
    }

    if (!Productdata || Productdata.length === 0) {
      console.warn("Product data is empty.");
      return totalPrice;
    }

    // Iterate over cart quantities
    cartQuantities.forEach((quantity, itemId) => {
      const row = Productdata.find((item) => item._id === itemId);

      if (row && row.priceRange) {
        // Find the applicable price range
        const applicablePriceRange = row.priceRange.find(
          (range) =>
            quantity >= range.minQuantity && quantity <= range.maxQuantity
        );

        if (applicablePriceRange) {
          // Add the price for this item to the total
          totalPrice += quantity * applicablePriceRange.price;
        } else {
          // Fallback to last price range if quantity exceeds defined ranges
          const lastRange = row.priceRange[row.priceRange.length - 1];
          if (quantity > lastRange.maxQuantity) {
            totalPrice += quantity * lastRange.price;
          } else {
            console.warn(
              `No matching price range for item ${itemId} with quantity ${quantity}.`
            );
          }
        }
      } else {
        console.warn(`No price range or product found for item ID: ${itemId}`);
      }
    });

    return totalPrice;
  };

  useEffect(() => {
    const productIdAndQuantities = Array.from(cartQuantities, ([productId, quantity]) => ({
      productId,
      quantity,
    }));
    setCartTotalItem(productIdAndQuantities);
    const totalPrice = calculateTotalPrice();
    setTotalCartAmount(totalPrice);
  }, [cartQuantities, addedToCart]);

  function addToCartFormatter(cellContent, row) {
    const quantity = cartQuantities.get(row._id) || row.quantity || 0;
    const minimumQuantity = row?.minimumQuantity || 1;
  
    return (
      <div className="d-flex product-add justify-content-center" style={{ width: '190px' }}>
        {row?.isPublished ? (
          <>
            {addedToCart.has(row._id) ? ( // Check API flag or cart state
              <div>
                <div className="cart_qty mb-2 animate__animated animate__slideInRight">
                  <div className="input-group quantity-prod">
                    <button
                      type="button"
                      className="btn qty-left-minus"
                      onClick={() => handleDecrement(row._id)} // Decrease quantity
                      disabled={quantity <= minimumQuantity} // Disable decrement if at minimum quantity
                    >
                      <i className="fa fa-minus ms-0" />
                    </button>
                    <input
                      className="form-control input-number qty-input"
                      type="number"
                      value={quantity} // Use current quantity
                      onChange={(e) => handleChange(e, row._id)} // Handle input change
                    />
                    <button
                      type="button"
                      className="btn qty-right-plus"
                      onClick={() => handleIncrement(row._id)} // Increase quantity
                    >
                      <i className="fa fa-plus ms-0" />
                    </button>
                  </div>
                </div>
                <p className="mb-0 remove-cart" onClick={() => handleAddToCart(row._id)}>
                  Remove
                </p>
              </div>
            ) : (
              <button
                type="button"
                className="btn btn-info mx-2"
                onClick={() => handleAddToCart(row._id)}
              >
                <i className="fal fa-shopping-cart"></i> Add To Cart
              </button>
            )}
          </>
        ) : (
          <>
            <button
              data-tip
              data-for={`addToCart${row?._id}`} className="btn btn-secondary disabled mx-2" type="button" >
              <i className="fal fa-shopping-cart"></i> Add To Cart
            </button>
            <ReactTooltip place="bottom" id={`addToCart${row?._id}`}>
              This item cannot be added to the cart because it is inactive.
            </ReactTooltip>
          </>
        )}
      </div>
    );
  }

  const getPriceForQuantity = (itemId, quantity) => {
    const row = Productdata.find((item) => item._id === itemId);
    const priceRange = row?.priceRange;

    if (!priceRange || priceRange.length === 0) {
      console.error("No price range found for item ID:", itemId);
      return 0; // Default to 0 if no price range exists
    }

    // Find the price within the range
    const range = priceRange.find(
      (range) => quantity >= range.minQuantity && quantity <= range.maxQuantity
    );

    // If quantity exceeds the maximum range, use the last range's price
    if (!range) {
      console.warn("Quantity exceeds the maximum range, using last range price.");
      return priceRange[priceRange.length - 1].price;
    }

    return range.price;
  };

  const handleIncrement = (itemId) => {
    setCartQuantities((prevCartQuantities) => {
      const updatedQuantities = new Map(prevCartQuantities);
      const currentQuantity = updatedQuantities.get(itemId) || 0;
      const newQuantity = currentQuantity + 1; // Increment quantity
      updatedQuantities.set(itemId, newQuantity);
      return updatedQuantities;
    });

    // Update only the target product in Productdata
    setProductdata((prevProductdata) => {
      return prevProductdata.map((item) => {
        if (item._id === itemId) {
          const updatedQuantity = (cartQuantities.get(itemId) || 0) + 1;
          const updatedPrice = getPriceForQuantity(itemId, updatedQuantity);
          return { ...item, quantity: updatedQuantity, price: updatedPrice };
        }
        return item; // Keep other products unchanged
      });
    });
  };

  const handleDecrement = (itemId) => {
    setCartQuantities((prevCartQuantities) => {
      const updatedQuantities = new Map(prevCartQuantities);
      const currentQuantity = updatedQuantities.get(itemId) || 0;
      const newQuantity = Math.max(currentQuantity - 1, 1); // Ensure minimum quantity is 1
      updatedQuantities.set(itemId, newQuantity);
      return updatedQuantities;
    });

    // Update only the target product in Productdata
    setProductdata((prevProductdata) => {
      return prevProductdata.map((item) => {
        if (item._id === itemId) {
          const updatedQuantity = Math.max((cartQuantities.get(itemId) || 0) - 1, 1);
          const updatedPrice = getPriceForQuantity(itemId, updatedQuantity);
          return { ...item, quantity: updatedQuantity, price: updatedPrice };
        }
        return item; // Keep other products unchanged
      });
    });
  };

  const handleChange = (e, itemId) => {
    let newQuantity = Number(e.target.value); // Get the input value as a number
    const row = Productdata.find((item) => item._id === itemId);
    const minimumQuantity = row?.minimumQuantity || 1;

    // Validate quantity against minimum quantity
    if (newQuantity < minimumQuantity) {
      Swal.fire({
        icon: 'warning',
        title: 'Minimum Quantity',
        text: `The quantity cannot be less than ${minimumQuantity}.`,
        confirmButtonText: 'OK',
        timer: 2000,
      });
      newQuantity = minimumQuantity; // Reset to minimum quantity
    }

    // Update cart quantities
    setCartQuantities((prevCartQuantities) => {
      const updatedMap = new Map(prevCartQuantities);
      updatedMap.set(itemId, newQuantity); // Update quantity based on input
      return updatedMap;
    });

    // Update product data with recalculated price
    const updatedProductData = Productdata.map((item) => {
      if (item._id === itemId) {
        const price = getPriceForQuantity(itemId, newQuantity); // Calculate price
        console.log("Updated Price for Item:", itemId, price); // Debug log
        return { ...item, quantity: newQuantity, price }; // Update quantity and price
      }
      return item;
    });

    setProductdata(updatedProductData); // Update the state with new product data
  };

  // Example usage:
  const ProductManagment = async (filterArgs = [{ type: "objectId", manufactureId: userId }]) => {
    try {
      setLoader(true);

      // Construct payload
      const payload = {
        limit: sizePerPageOrg,
        page: currentPage,
        sortField: sort,
        sortOrder: sortOrder,
        // userId: userId,
        type: "all",
        search: searchText,
      };

      // Handle filter arguments or search text
      if (filterArgs?.length) {
        payload.filterArgs = filterArgs;
      } else if (searchText) {
        payload.search = searchText;
      }

      // Make API request
      const response = await postRequest('product/product-list-admin', payload);

      // Handle response data
      const data = response?.data || [];
      setTotalPage(data?.total);
      setCurrentFPage(data?.currentPage);
      setProductdata(data?.list);

      // Reset search text
      setSearchText('');
    } catch (error) {
      console.error('Error fetching product list:', error);
      // Optionally display error feedback to the user
    } finally {
      setLoader(false);
    }
  };

  const proceedTocart = async (_id) => {
    if (manufactuereId && manufactuereId !== _id) {
      Swal.fire({
        icon: 'warning',
        title: 'Cart Conflict',
        text: 'Cart already belongs to another manufacturer. If you proceed, the previous cart will be cleared, and this manufacturer\'s products will be added.',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Clear the previous cart and add products from the current manufacturer
          const res = await postRequest("order/admin/add-to-cart", {
            manufactureId: _id,
            products: cartTotalItem,
          });
          if (res.status) {
            Swal.fire({
              icon: 'success',
              title: 'Products Added!',
              text: 'Products added to cart successfully!',
              confirmButtonText: 'OK',
            }).then((result) => {
              if (result.isConfirmed) {
                history.push('/cart');
              }
            });
            ProductManagment();
          } else {
            toast.error("Something went wrong");
            setLoader(false);
          }
        }
      });
      return;
    }
    // If manufacturer ID matches or no conflict
    const res = await postRequest("order/admin/add-to-cart", {
      manufactureId: _id,
      products: cartTotalItem,
    });
    if (res.status) {
      Swal.fire({
        icon: 'success',
        title: 'Products Added!',
        text: 'Products added to cart successfully!',
        confirmButtonText: 'OK',
      }).then((result) => {
        if (result.isConfirmed) {
          history.push('/cart');
        }
      });
      ProductManagment();
    } else {
      toast.error("Something went wrong");
      setLoader(false);
    }
  };
  
  ///fetchcartMatchtoManufretuer
  const fetchCartLength = async () => {
    try {
      const response = await postRequest('order/admin/view-cart');
      const data = response?.data || [];
      setManufactuereId(response?.data?.manufactureId);
    } catch (error) {
      console.error('Error fetching product list:', error);
    } finally {
    }
  };
  useEffect(() => {
    fetchCartLength();
  }, [])

  return (
    <>
      <React.Fragment>

        <ToastContainer />
        <Row>
          {/* <Col className="12">
            <div className="page-title-box">
              <h4>Hotel Product Management</h4>

              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item active">Product Management</li>:{" "}
                <li className="breadcrumb-item">Product List</li>
              </ol>
            </div>
          </Col> */}

          <Col className="col-12">
            <Card>
              {loader ? (
                <CardBody style={{ height: "100px" }}>
                  <Spinner
                    color="info"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      position: "absolute",
                      left: "50%",
                    }}
                  >
                    Loading...
                  </Spinner>
                </CardBody>
              ) : (
                <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                        page: currentFPage,
                        sizePerPage: sizePerPageOrg,
                        totalSize: totalPage,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={Productdata}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                                <Col className="col-lg-12 d-flex mb-3">
                                  <label className="mb-0 text-label">
                                    Page Size
                                  </label>
                                  <select
                                    value={sizePerPageOrg}
                                    onChange={handleChange}
                                    className="form-select"
                                    style={{ width: "7%" }}
                                  >
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                  </select>

                                  <label className="mb-0 text-label ms-3">
                                    Sort By:
                                  </label>
                                  <select
                                    value={sort}
                                    onChange={handlesorting}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="Name">
                                      {" "}
                                      Product Name
                                    </option>


                                    <option value="description">Description</option>
                                    <option value="unit">Unit</option>
                                    <option value="status">status</option>

                                  </select>
                                  <label className="mb-0 text-label ms-3">
                                    Sort Order:
                                  </label>
                                  <select
                                    value={sortOrder}
                                    onChange={handlesortOrder}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="asc"> Ascending</option>
                                    <option value="desc">Descending</option>

                                  </select>
                                  <div className="filter-item">
                                    <input
                                      type="search"
                                      placeholder="Search"
                                      value={searchText}
                                      class="form-control"
                                      onChange={(e) =>
                                        setSearchText(e.target.value)
                                      }
                                      style={{ width: "30%" }}
                                    />
                                    <button
                                      onClick={() => {
                                        ProductManagment();
                                      }}
                                      type="button"
                                      className="btn btn-primary mx-2"
                                    >
                                      Search
                                    </button>
                                    <button
                                      type="button"
                                      onClick={handleReload}
                                      className="btn btn-danger mx-2"
                                    >
                                      Reset
                                    </button>


                                  </div>
                                </Col>

                                {cartTotalItem?.length > 0 &&
                                  <Col className="card-box-cart">
                                    <div>
                                      <h4>Total Items :<span style={{ color: '#000' }}>{cartTotalItem?.length}</span> </h4>
                                      <h4>Total Amount : <span style={{ color: '#000' }}> ${totalCartAmount}</span></h4>
                                    </div>
                                    <button
                                      type="button"
                                      onClick={() => proceedTocart(Productdata?.[0]?.manufactureId)}
                                      className="btn place-btn btn-info"
                                    >
                                      Proceed to Checkout
                                    </button>
                                  </Col>}

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                    onTableChange={handleTableChange}
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                          <Row>
                            <Col className="col-lg-12 text-end">
                              <div className="text-md-right">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>

      </React.Fragment>
      <FilterModal
        show={model}
        closeModal={closeModal}
        components={components}
      />
    </>
  );
};

export default ProductesTable;
